/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const ChartWrapper = styled(Box)(({height}) => ({
  width: '100%',
  overflow: 'hidden',
  height: `${height}px`,
}));
